import React from 'react';
const EducationLevelPage = React.lazy(() => import('pages/EducationLevel/EducationLevelPage'));
const EducationLevelAddPage = React.lazy(() => import('pages/EducationLevel/EducationLevelAddPage'));

const EducationLevelRoute = [
  {
    path: '/education-level',
    exact: true,
    name: 'Danh sách bằng cấp',
    function: 'MD_EDUCATIONLEVEL_VIEW',
    component: EducationLevelPage,
  },
  {
    path: '/education-level/add',
    exact: true,
    name: 'Thêm mới bằng cấp',
    function: 'MD_EDUCATIONLEVEL_ADD',
    component: EducationLevelAddPage,
  },
  {
    path: '/education-level/edit/:education_level_id',
    exact: true,
    name: 'Chỉnh sửa bằng cấp',
    function: 'MD_EDUCATIONLEVEL_EDIT',
    component: EducationLevelAddPage,
  },
  {
    path: '/education-level/detail/:education_level_id',
    exact: true,
    name: 'Chi tiết bằng cấp',
    function: 'MD_EDUCATIONLEVEL_VIEW',
    component: EducationLevelAddPage,
  },
];

export default EducationLevelRoute;
